// src/api/auth.js
import API from "../axiosConfig";

export const getUsers = async () => {
  try {
    const response = await API.get("/agents");
    return response.data; // Adjust based on your API response structure
  } catch (error) {
    throw error; // Rethrow error to be handled in the component
  }
};

export const createUser = async (payload) => {
  try {
    const response = await API.post("/agents/register", { ...payload });
    return response.data; // Adjust based on your API response structure
  } catch (error) {
    throw error; // Rethrow error to be handled in the component
  }
};

export const updateUser = async (payload) => {
  try {
    const response = await API.put(`/agents/${payload.id_agent}`, {
      ...payload,
    });
    return response.data; // Adjust based on your API response structure
  } catch (error) {
    throw error; // Rethrow error to be handled in the component
  }
};

export const getPositiveBalanceUsers = async () => {
  try {
    const response = await API.get("/agents/positive-balance");
    return response.data; // Adjust based on your API response structure
  } catch (error) {
    throw error; // Rethrow error to be handled in the component
  }
}

export const getAgentWithRoles = async () => {
  try {
    const response = await API.get("/agents-with-roles");
    return response.data; // Adjust based on your API response structure
  } catch (error) {
    throw error; // Rethrow error to be handled in the component
  }
};